import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t py-6">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
        <p>&copy; 2024 D9 Network, Inc. {t('common.allRightsReserved')}</p>
      </div>
    </footer>
  );
}
